




























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { VersionString } from '@/constants/environment';

@Component({})
export default class VerificationResult extends Vue
{
	errors : any[] = [];
	verificationResult : string = "";

	mounted()
	{
	    this.verification();
	}

	async verification()
	{
	    const code = this.$route.query.code;
	    if (code != null)
	    {
	        try 
	        {
	            let res = await this.$http.post('verifyemail', null, { params: { code }});
	            if (res.data.error)
	            {
	                this.verificationResult = `Email verification failed: ${res.data.error}`;
	                return;
	            }
	            this.verificationResult = 'Successfully verified your email.';
	            return;
	        } 
	        catch (error) 
	        {
	            console.log(error);

	            let res = error.response;
	            if (res.data.error)
	            {
	                this.verificationResult = `Email verification failed: ${res.data.error}`;
	                return;
	            }
	            this.verificationResult = 'Internal error, please try again.';
	            return;
	        }
	    }
	    this.verificationResult = 'Verification code is missing.';
	    return;
	}

	navigateToLogin()
	{
	    this.$router.push('/');
	}

	get VersionString() 
	{
	    return VersionString; 
	}
}
